import React from "react";
import TransferList from "./TransferList";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setState } from "./editScenarioNewSlice";

export default function CustomerCgSearchResult() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.editScenarioNew);
	const { custsCGs, selectedCustsCGs, editScDetails, is_customer_refresh } = setupState;

	useEffect(() => {
		if (editScDetails !== null) {
			// let tempList = [];
			// if (editScDetails.customers.length > 0) {
			// 	editScDetails.customers.forEach((cust) => {
			// 		tempList.push(cust.customer);
			// 	});
			// }
			// if (editScDetails.customerGroups.length > 0) {
			// 	editScDetails.customerGroups.forEach((cg) => {
			// 		tempList.push(cg.customerGroup);
			// 	});
			// }
			// console.log(tempList);
			// dispatch(setState("selectedCustsCGs", tempList));
		}
	}, [editScDetails]);

	return (
		<Box container columns={12}
			sx={{
				mt: 4,
				p: 2,
				border: 1,
				borderRadius: 1,
				borderColor: "#c6c6c6",
			}}
		>
			<Box item sm={4} sx={{ mt: 0 }}>
				<Typography
					sx={{ fontWeight: "bold" }}
					leftList={custsCGs}
					rightList={selectedCustsCGs}
				>
				
				</Typography>
			</Box>

			<Box item sm={4}  sx={{ mt: 1 }}>
				<TransferList
					leftList={custsCGs}
					rightList={selectedCustsCGs}
					leftState={"custsCGs"}
					rightState={"selectedCustsCGs"}
					isCustomer = {true}
					refresh = {is_customer_refresh}
				/>
			</Box>
		</Box>
	);
}
